<template>
  <div class="config-image__area clearfix">
    <div :class="titleBarClasses">
      <div class="row">
        <div class="col-xs-12">
          <div class="config-image__selection-type">
            <span
              v-if="!groupIsValid && showValidation"
              class="photoset__fail"
            >!</span>
            {{ optionProduct.ProductRetailName }}
          </div>
          <div class="config-image__selection-quantity">
            <contentful-text
              v-if="remainingEmptyFramesCount === 1"
              :item="contentfulText('mix-match-photo-group-subtitle-singular')"
              :data="{ numPhotos: remainingEmptyFramesCount }"
            />
            <contentful-text
              v-if="remainingEmptyFramesCount > 1"
              :item="contentfulText('mix-match-photo-group-subtitle-plural')"
              :data="{ numPhotos: remainingEmptyFramesCount }"
            />
          </div>
        </div>
      </div>
    </div>
    <photo-selection-selected-frame
      v-for="(selectedFrame, selectionSlotNumber) in selectedFrames"
      :selected-frame-id="selectedFrame.frameId"
      :quantity="selectedFrame.quantity"
      :key="`selection-${optionProduct.CatalogPackageOptionProductID}-${selectionSlotNumber}`"
      :option-product="optionProduct"
      @change-photo-clicked="handleSelectPhotoClicked(selectionSlotNumber)"
      @remove-clicked="handleRemoveClicked(selectionSlotNumber)"
      @quantity-updated="handleQuantityUpdated($event, selectionSlotNumber)"
    />
    <photo-selection-placeholder
      v-for="remainingEmptyFramesIndex in remainingEmptyFramesCount"
      :key="`placeholder-${optionProduct.CatalogPackageOptionProductID}-${remainingEmptyFramesIndex}`"
      :is-next-selection="remainingEmptyFramesIndex == 1"
      :class="placeholderClasses"
      @select-photo-clicked="handleSelectPhotoClicked((selectedFrames.length + (remainingEmptyFramesIndex - 1)))"
    />
    <select-photo-modal
      :show="showSelectPhotoModal"
      @close="showSelectPhotoModal = false"
      @photo-selected="handlePhotoSelected"
    />
  </div>
</template>

<script>
import PhotoSelectionSelectedFrame from './Slot/SelectedFrame'
import PhotoSelectionPlaceholder from './Slot/Placeholder'
import ContentfulMixin from '@Shared/mixins/contentful'
import SelectPhotoModal from '@Shared/components/catalog/SelectPhotoModal/SelectPhotoModal'

export default {
  name: 'PhotoSelectionGroup',
  components: {
    PhotoSelectionSelectedFrame,
    PhotoSelectionPlaceholder,
    SelectPhotoModal
  },
  mixins: [
    ContentfulMixin
  ],
  props: {
    optionProduct: { type: Object, default: null }
  },
  data () {
    return {
      showSelectPhotoModal: false,
      activeSlotNumber: null
    }
  },
  computed: {
    titleBarClasses () {
      return {
        'config-image__title-bar': true,
        'config-image__title-bar--alt-gradimages': true,
        'config-image__title-bar--invalid': !this.groupIsValid && this.showValidation
      }
    },
    groupIsValid () {
      return this.remainingEmptyFramesCount === 0
    },
    showValidation () {
      return this.$store.state.showMixMatchValidation
    },
    content () {
      return this.$store.state.mixMatchPhotoSelectionModuleContent
    },
    selectedFrames () {
      return this.$store.getters.getSelectedFramesByProduct(this.optionProduct.CatalogPackageOptionProductID)
    },
    remainingEmptyFramesCount () {
      return this.$store.getters.getRemainingEmptyFramesByProduct(this.optionProduct.CatalogPackageOptionProductID)
    },
    alwaysShowRetouchingModal () {
      return this.$store.state.catalogPageCommon.alwaysShowRetouchingModal
    },
    placeholderClasses () {
      return {
        'placeholder--group-has-selection': this.remainingEmptyFramesCount !== this.optionProduct.Qty
      }
    }
  },
  methods: {
    handleSelectPhotoClicked (selectionSlotNumber) {
      this.activeSlotNumber = selectionSlotNumber
      this.showSelectPhotoModal = true
    },
    handlePhotoSelected (data) {
      this.$store.commit('updateMixMatchSelection', { catalogPackageOptionProductId: this.optionProduct.CatalogPackageOptionProductID, slotNumber: this.activeSlotNumber, frameId: data.frameInfo.FrameID, quantity: 1 })

      if (this.alwaysShowRetouchingModal === true) {
        document.dispatchEvent(new CustomEvent('retouchingModal.show', {
          detail: { frameId: data.frameInfo.FrameID, alwaysShow: false }
        }))
      }

      this.activeSlotNumber = null
    },
    handleRemoveClicked (slotNumber) {
      this.$store.commit('removeMixMatchSelection', { catalogPackageOptionProductId: this.optionProduct.CatalogPackageOptionProductID, slotNumber })
    },
    handleQuantityUpdated (quantity, slotNumber) {
      this.$store.commit('updateMixMatchSelectionQuantity', { catalogPackageOptionProductId: this.optionProduct.CatalogPackageOptionProductID, slotNumber, quantity })
    }
  }
}
</script>

<style scoped lang="scss">
.placeholder--group-has-selection {
  height: 342px;

  @media screen and (min-width: $screen-sm-min) {
    height: 378px;
  }

  @media screen and (min-width: $screen-md-min) {
    height: 278px;
  }

  @media screen and (min-width: $screen-lg-min) {
    height: 325px;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/default/catalog-mix/components/PhotoSelection/Group.vue